import setServiceConfig from './set-service-config';

export default {
  setServiceConfig,
};
